import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { AUTH_LEVELS } from '../auth/Authorized';
import UsersLoader from '../loaders/UsersLoader';
import UsersOverview from './UsersOverview';
import RolesOverview from './roles/RolesOverview';
import OrgsOverview from './orgs/OrgsOverview';
import Editor from './Editor';

import './user-mgmt.css';

const UserManagement = ({ showOrganizations, scrollTop }) => (
  <div className="row grid-container-lg user-mgmt">
    <div className="view">
      <UsersOverview scrollTop={scrollTop} />
      <RolesOverview scrollTop={scrollTop} />
      {showOrganizations && <OrgsOverview scrollTop={scrollTop} />}
    </div>
    <div className="edit">
      <Editor />
    </div>
    <UsersLoader />
  </div>
);

UserManagement.propTypes = {
  scrollTop: PropTypes.func.isRequired,
  showOrganizations: PropTypes.bool.isRequired,
};

export default connect(({ user: { userAuthLevel } }) => ({
  showOrganizations: userAuthLevel === AUTH_LEVELS.SUPER_ADMIN,
}))(UserManagement);
